import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { motion, AnimatePresence } from 'framer-motion';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const questions = [
    {
      q: "Hva koster SalesWork CRM?",
      a: "Vi har tre pakker: Start (599,-), Vekst (990,-) og Enterprise (2990,-). Prisene er per bruker per måned. Du kan betale med kort eller faktura."
    },
    {
      q: "Er det bindingstid?",
      a: "Nei, vi har ingen bindingstid på månedlige abonnementer. Du kan si opp når som helst, og abonnementet løper ut perioden du har betalt for."
    },
    {
      q: "Hvordan fungerer 'Partner' og 'Selger' portalene?",
      a: "Dette er interne portaler for de som videreselger SalesWork. En partner kan registrere kunder via sin unike lenke og få provisjon. Portalen gir full oversikt over salg og inntjening."
    },
    {
      q: "Kan jeg importere data fra mitt gamle system?",
      a: "Ja, vi støtter import via Excel/CSV. Vi har også direkte integrasjon mot Brønnøysundregistrene for å hente ferske firmadata."
    },
    {
      q: "Tilbyr dere faktura (EHF)?",
      a: "Ja, bedrifter kan velge faktura som betalingsmetode under registrering. Vi støtter EHF og PDF-faktura."
    },
    {
      q: "Er systemet GDPR-kompatibelt?",
      a: "Absolutt. Vi har innebygde funksjoner for samtykkehåndtering, sletteforespørsler og datakontroll. Alle data lagres trygt i Europa."
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-900">
      {/* Nav */}
      <nav className="bg-white border-b border-slate-200 py-4 px-6 md:px-8 flex justify-between items-center sticky top-0 z-50">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center font-black text-white">S</div>
          <span className="text-lg font-black">SalesWork CRM</span>
        </Link>
        <Link to="/signup" className="px-5 py-2 bg-slate-900 text-white rounded-lg font-bold text-sm">Prøv Gratis</Link>
      </nav>

      <div className="max-w-3xl mx-auto px-6 py-20">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-black text-slate-900 mb-4">Ofte stilte spørsmål</h1>
          <p className="text-slate-500 font-medium">Lurer du på noe? Her finner du svarene.</p>
        </div>

        <div className="space-y-4">
          {questions.map((item, index) => (
            <div key={index} className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
              <button 
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left font-bold text-slate-900 hover:bg-slate-50 transition-colors"
              >
                {item.q}
                <SafeIcon icon="▼" className={`text-slate-400 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} />
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div 
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    className="border-t border-slate-100"
                  >
                    <div className="p-6 pt-2 text-slate-600 leading-relaxed">
                      {item.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center bg-blue-50 p-8 rounded-3xl border border-blue-100">
          <h3 className="font-black text-lg text-blue-900 mb-2">Fant du ikke svaret?</h3>
          <p className="text-blue-700 mb-6 text-sm">Vårt team er klare til å hjelpe deg.</p>
          <div className="flex justify-center gap-4">
            <a href="mailto:support@saleswork.no" className="px-6 py-3 bg-white text-blue-700 rounded-xl font-bold text-sm shadow-sm hover:bg-blue-50 border border-blue-200">Send e-post</a>
            <Link to="/book-demo" className="px-6 py-3 bg-blue-600 text-white rounded-xl font-bold text-sm shadow-lg hover:bg-blue-700">Book en prat</Link>
          </div>
        </div>
      </div>

      <footer className="bg-[#0B1426] text-white py-12 text-center text-sm border-t border-white/10">
        <p>&copy; 2024 SalesWork AS.</p>
      </footer>
    </div>
  );
};

export default FAQ;